import type { NotificationBroadcastPayloadBase } from "./notification-broadcast.type";

import { isValidObject } from "@/utilities/object";

import { NOTIFICATION_BROADCAST_TYPE } from "./notification-broadcast.enum";

/**
 * TYPES GUARDS
 */
export const isValidNotificationBroadcastBase = (
  payload: unknown
): payload is NotificationBroadcastPayloadBase =>
  isValidObject(payload) &&
  "id" in payload &&
  typeof payload.id === "string" &&
  "event_type" in payload &&
  typeof payload.event_type === "string" &&
  Object.values(NOTIFICATION_BROADCAST_TYPE).includes(
    payload.event_type as NOTIFICATION_BROADCAST_TYPE
  ) &&
  "context" in payload &&
  typeof payload.context === "string";

export const isNotificationBroadcastNamedModel = (
  payload: unknown
): payload is { id: number; name: string } =>
  isValidObject(payload) &&
  "id" in payload &&
  typeof payload.id === "number" &&
  "name" in payload &&
  typeof payload.name === "string";
